import { HttpInterceptorFn } from '@angular/common/http';
import { properties } from '../../../environments/properties';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes(properties.serviceLogin)) {
    return next(req);
  }
  const token = sessionStorage.getItem('token');
  if (!token) {
    return next(req);
  }
  return next(
    req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }),
  );
};
